export type ReferencedByItems = ReferencedCanvasSteps | ReferencedItemsCategory;

interface ReferencedItemsCategory {
  type: "Campaigns" | "Segments" | "Workflows" | string;
  items: ReferencedItem[];
}

interface ReferencedCanvasSteps {
  type: "Workflow_steps";
  items: ReferencedCanvasStep[];
}

interface ReferencedItem {
  id: string;
  name: string;
}

export interface ReferencedCanvasStep extends ReferencedItem {
  j_id: string;
}

export interface ErrorContext {
  // eslint-disable-next-line camelcase
  referenced_by_items?: ReferencedByItems[];
}

export class BrazeServerSideError extends Error {
  errorContext?: ErrorContext;

  constructor(errorContext: ErrorContext, message?: string) {
    super(message);
    this.errorContext = errorContext;
  }
}
